/* Yeti perf: rewrite Judge.me imgix review images for 80% size reduction */
(function(){
  var GRID_W = 300;   // review grid thumbnails
  var LARGE_W = 800;  // expanded reviews

  function rewrite(url, targetW) {
    try {
      if (!url || url.indexOf('judgeme.imgix.net') === -1) return url;
      var u = new URL(url);
      // Strip existing width param
      u.searchParams.delete('w');
      u.searchParams.delete('width');
      // Set width + modern format via imgix auto=format (serves AVIF/WebP when browser supports)
      u.searchParams.set('w', targetW);
      if (!u.searchParams.has('auto')) u.searchParams.set('auto', 'format,compress');
      if (!u.searchParams.has('q')) u.searchParams.set('q', '75');
      return u.toString();
    } catch (e) { return url; }
  }

  function processImg(img) {
    if (img.dataset.yetiOptimized) return;
    var rect = img.getBoundingClientRect();
    var target = rect.width > 400 || rect.height > 400 ? LARGE_W : GRID_W;
    var newSrc = rewrite(img.currentSrc || img.src, target);
    if (newSrc && newSrc !== img.src) {
      img.src = newSrc;
      img.dataset.yetiOptimized = '1';
    }
  }

  function scan() {
    document.querySelectorAll('img[src*="judgeme.imgix.net"], img[data-src*="judgeme.imgix.net"]').forEach(processImg);
  }

  // Initial + observe mutations (Judge.me injects review section lazily)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  var observer = new MutationObserver(function(mutations){
    var hasNew = false;
    for (var m of mutations) {
      for (var n of m.addedNodes) {
        if (n.nodeType === 1 && (n.tagName === 'IMG' || n.querySelector)) { hasNew = true; break; }
      }
    }
    if (hasNew) requestAnimationFrame(scan);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
